// hacky way to generate optimistic issue id, not ideal but have to do it for now
// to react backwards compatibility with current ICC
let lastCardId = 0;

export const generateId = (): number => {
	lastCardId -= 1;
	return lastCardId;
};
